import { render } from "./AccountTypeSelectionModal.vue?vue&type=template&id=305015fd"
import script from "./AccountTypeSelectionModal.vue?vue&type=script&lang=js"
export * from "./AccountTypeSelectionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__